import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-value"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.356 3C20.394 3 22.856 5.5 22.856 9C22.856 15.6009 16.1868 19.5341 13.33 21.219C13.1573 21.3208 12.9985 21.4145 12.856 21.5C12.7134 21.4145 12.5546 21.3208 12.3819 21.219C9.52512 19.5341 2.85596 15.6009 2.85596 9C2.85596 5.5 5.35596 3 8.35596 3C10.216 3 11.856 4 12.856 5C13.856 4 15.496 3 17.356 3Z" })
], -1)
const _hoisted_3 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    tabindex: "0",
    class: _normalizeClass({ 'favorite-icon': true, active: _ctx.favorite }),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toogleFavorite && _ctx.toogleFavorite(...args)), ["stop"])),
    onKeyup: [
      _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toogleFavorite && _ctx.toogleFavorite(...args)), ["space"])),
      _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toogleFavorite && _ctx.toogleFavorite(...args)), ["enter"]))
    ],
    "data-role": "favorite",
    "data-value": _ctx.favorite ? 'true' : 'false'
  }, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('srp2.vehicleTile.favoriteIconLabel')), 1)
  ], 42, _hoisted_1))
}